import { render, staticRenderFns } from "./SystemSecurityDetails.vue?vue&type=template&id=2556fef5&"
import script from "./SystemSecurityDetails.vue?vue&type=script&lang=js&"
export * from "./SystemSecurityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports